import { getCommodityInfo, type AddOrderData } from '@/views/power/service';
import { CorporateTransferApplyStatus } from '@/types/teamEdition.d';
import { CORPORATE_PAYMENT_ERROR } from './constants';
import type { CorporatePaymentResult, CorporatePaymentState } from './types';

/** 仅由业务后端建单；缺少凭证时不回退 SDK，避免重复订单。 */
export async function createCorporateOrder(params: AddOrderData, signal?: AbortSignal): Promise<CorporatePaymentResult> {
  const { data } = await getCommodityInfo({ ...params, payChannel: 'corporate' }, { signal, notToast: true });
  const innerOrderId = typeof data?.innerOrderId === 'string' ? data.innerOrderId.trim() : '';
  const corporateId = typeof data?.corporateId === 'string' ? data.corporateId.trim() : '';
  if (!innerOrderId || !corporateId || typeof data.totalAmount !== 'number' ||
      !Number.isFinite(data.totalAmount) || data.totalAmount < 0) {
    throw new Error(CORPORATE_PAYMENT_ERROR);
  }
  // 旧页面的 orderId 是中台查询标识；历史订单仍从 transactionId 恢复。
  return { commodity: { ...data, innerOrderId, corporateId }, order: { orderId: innerOrderId, corporateId } };
}

/** 替换当前订单并清空旧合同／详情，调用方随后编排弹窗步骤。 */
export function commitCorporateOrder(state: CorporatePaymentState, result: CorporatePaymentResult): void {
  const { commodity, order } = result;
  state.corporateTransferOrderInfo = order;
  state.goodInfo = {} as CorporatePaymentState['goodInfo'];
  state.createContractResponse = {} as CorporatePaymentState['createContractResponse'];
  state.corporateTransferApplyStatus = CorporateTransferApplyStatus.NOT_APPLY;
  state.orderStatus = {
    innerOrderId: order.orderId!, orderStatus: 'NOTPAY', orderType: commodity.orderType,
    payChannel: 'corporate', subject: commodity.subject ?? '',
    headCount: commodity.headCount, teamName: commodity.teamName, memberType: commodity.memberType,
    ctime: commodity.ctime, startTime: '确认完成后生效', endTime: '-',
    corporateTransferTotalAmount: commodity.totalAmount! / 100
  };
}
